
$(function(){ 

    $("body").addClass("active");

    Fancybox.bind("[data-fancybox]", {});

    setTimeout(function(){
        AOS.init();
    },300)
   
    const $input = $('#cmdk-input');
    const $wrapper = $(".predictive-search-form__content-wrapper");

    $input.on('focus', function() {
        $wrapper.addClass("active");
    });

    $input.on('input keydown', function() {
        $wrapper.addClass("active");
    });

    $input.on('blur', function() {
        setTimeout(() => {
            $wrapper.removeClass("active");
        }, 300);
    });

    $(document).on("click", "#shopify-block-AcXFDK0dSc2FPNE5Ga__icon_inibz4, .text-block--AVmhKUFhweWhmUHA1K__text_Q9r4kb", function(e){
       e.preventDefault();
       $(".facets-toggle__wrapper button").trigger("click");
    });

    let $btnshop = $("#BuyButtons-ProductSubmitButton-AaFpTT2NacG5Sc2xTa__add-to-cart");
    if ($btnshop.length > 0) {
        let btnOffset = $btnshop.offset().top + $btnshop.outerHeight();

        let $header = $('header-component[data-sticky-state="active"]');
        if ($header.length > 0) {
            btnOffset -= $header.outerHeight(); // restamos la altura del header
        }

        $(window).on("scroll", function () {
            if ($(window).scrollTop() > btnOffset) {
                $btnshop.parent().addClass("button-fixed-bottom");
            } else {
                $btnshop.parent().removeClass("button-fixed-bottom");
            }
        });

        // Recalcular si cambia el tamaño de la ventana
        $(window).on("resize", function () {
            btnOffset = $btnshop.offset().top + $btnshop.outerHeight();
        });
    }

    
    


   
});